import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

const initialForm = {
  name: "",
  email: "",
  phone: "",
  commodity: "",
  quantity: "",
  country: "",
  message: "",
};

export const QuoteModal = ({ open, onOpenChange }) => {
  const [form, setForm] = useState(initialForm);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success("Quote request received", {
      description: "Our team will get back to you shortly. (Form submission is a preview stub — backend integration coming soon.)",
    });
    setForm(initialForm);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="quote-modal" className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-heading text-[#042D1F]">Request a Quote</DialogTitle>
          <DialogDescription>
            Share your requirement and our export team will get in touch with you.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-1.5">
            <Label htmlFor="quote-name">Full Name</Label>
            <Input id="quote-name" data-testid="quote-form-name" required value={form.name} onChange={handleChange("name")} placeholder="Your name" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="quote-email">Email</Label>
            <Input id="quote-email" type="email" data-testid="quote-form-email" required value={form.email} onChange={handleChange("email")} placeholder="you@company.com" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="quote-phone">Phone</Label>
            <Input id="quote-phone" data-testid="quote-form-phone" value={form.phone} onChange={handleChange("phone")} placeholder="+1 234 567 890" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="quote-country">Country</Label>
            <Input id="quote-country" data-testid="quote-form-country" value={form.country} onChange={handleChange("country")} placeholder="Destination country" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="quote-commodity">Commodity / Product</Label>
            <Input id="quote-commodity" data-testid="quote-form-commodity" value={form.commodity} onChange={handleChange("commodity")} placeholder="Product of interest" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="quote-quantity">Quantity</Label>
            <Input id="quote-quantity" data-testid="quote-form-quantity" value={form.quantity} onChange={handleChange("quantity")} placeholder="Estimated quantity" />
          </div>
          <div className="sm:col-span-2 space-y-1.5">
            <Label htmlFor="quote-message">Message</Label>
            <Textarea id="quote-message" data-testid="quote-form-message" value={form.message} onChange={handleChange("message")} placeholder="Tell us more about your requirement" rows={4} />
          </div>
          <div className="sm:col-span-2 flex justify-end gap-3 pt-2">
            <Button type="button" variant="outline" data-testid="quote-form-cancel" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit" data-testid="quote-form-submit" className="bg-[#0B4F37] hover:bg-[#042D1F] text-white">
              Submit Request
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
